module.exports = __webpack_public_path__ + "img/3-3-2-1.f6c0a622.png";